import { render, staticRenderFns } from "./nutrition-step-three.html?vue&type=template&id=229078ce&scoped=true&"
import script from "./nutrition-step-three.js?vue&type=script&lang=js&"
export * from "./nutrition-step-three.js?vue&type=script&lang=js&"
import style0 from "./nutrition-step-three.scss?vue&type=style&index=0&id=229078ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229078ce",
  null
  
)

export default component.exports